import { titleCase as coreTitleCase } from 'title-case';

export function titleCase(string) {
  return coreTitleCase(string.replace(/_/g, ' ').toLowerCase());
}
